var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 698 541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-43,417V125.06H655V217c-.76-.63-1.58-1.22-2.29-1.9l-88.88-85.73c-1.27-1.22-2.58-2.42-4.63-4.36q-176.72,176.7-353,353.05L50.61,322.49C40.36,333.58,30.53,345,19.92,355.55-.82,376.26-22,396.54-43,417Z",
    transform: "translate(43 -125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-43,417c21-20.46,42.18-40.74,62.92-61.45,10.61-10.59,20.44-22,30.69-33.06L206.16,478.05q176.7-176.7,353-353c2,1.94,3.36,3.14,4.63,4.36l88.88,85.73c.71.68,1.53,1.27,2.29,1.9v1c-1.36,1.19-2.79,2.32-4.06,3.59Q430.74,441.75,210.59,661.94c-1.28,1.27-2.4,2.7-3.59,4.06h-2c-.84-1-1.61-2.08-2.53-3Q81.24,541.74-40,420.52c-.93-.92-2-1.69-3-2.52Z",
    transform: "translate(43 -125)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207,666c1.19-1.36,2.31-2.79,3.59-4.06q220.16-220.2,440.35-440.36c1.27-1.27,2.7-2.4,4.06-3.59V666Z",
    transform: "translate(43 -125)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-43,418c1,.83,2.07,1.6,3,2.52Q81.25,541.75,202.47,663c.92.92,1.69,2,2.53,3H-43Z",
    transform: "translate(43 -125)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.37245a57.svg";
export { ForwardRef as ReactComponent };